import { useEffect, useRef } from 'react'
// import { createJourneyPageURL } from 'src/common/utils'

import { STORAGE_KEYS } from 'src/constants'

export const JourneyIframe = () => {
  const ref = useRef<HTMLIFrameElement>(null)

  const token = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)
  useEffect(() => {
    if (!ref.current?.contentWindow || !token) return

    ref.current.contentWindow.postMessage({ token }, '*')
  }, [ref.current?.contentWindow, token])

  // const journeyPageUrl = `${createJourneyPageURL()}/auth`
  return <iframe ref={ref} hidden title="Journey" />
}
